import React from 'react';
import { Col } from 'antd';

/* eslint-disable react/prop-types */
const getBreakpoints = (bps = {}, large) => ({
  xs: large ? 19 : (bps.span || bps.xs || 5),
  sm: large ? 19 : (bps.span || bps.sm || bps.xs || 5),
  md: large ? 18 : (bps.span || bps.md || 6),
  lg: large ? 19 : (bps.span || bps.lg || bps.md || 5),
  xl: large ? 20 : (bps.span || bps.xl || bps.lg || bps.md || 4),
  xxl: large ? 21 : (bps.span || bps.xxl || bps.xl || bps.lg || bps.md || 3),
  ...bps,
});

const LabelValue = ({
  label,
  value,
  large,
  labelBps,
  valueBps,
  valueStyle,
}) => (
  <>
    {/* {large && <Col span={24} />} */}
    {!!label && (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Col {...getBreakpoints(labelBps)}>
        <b>
          {label}
          :
        </b>
      </Col>
    )}
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <Col {...getBreakpoints(valueBps, large)} style={valueStyle}>
      {value}
    </Col>
  </>
);

export default LabelValue;
